// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
Widgets.Notification = Widgets.Base.inherit({

    message: '',

    init: function(options) {
        this.parent.init(options);
        this.message = options.message;
        this.build();
    },

    definition: function() {
        return [
        '.notification-widget',
        ['.notification-widget-message', this.message]
        ];
    }

});
